export default "__VITE_ASSET__CUSYdiuF__"